<template>
<div style="margin: 0 30px;padding-bottom: 20px">
  <el-row>
    <el-col :span="4">
      <div style="width: 120px;height: 160px;">
        <img style="width: 110px;height: 130px" :src="servicePerson.service_personnel_photo ? servicePerson.service_personnel_photo : 'static/mapIcon/index_popup_img2.png'">
      </div>
    </el-col>
    <el-col :span="20">
      <el-col :span="12">
        <div class="line-info">
          <span class="line-info-title">姓名：</span><span>{{ servicePerson.service_personnel_name }}</span>
        </div>
        <div class="line-info">
          <span class="line-info-title">出生日期：</span><span v-if="servicePerson.service_personnel_birth_date !== '0000-00-00'">{{servicePerson.service_personnel_birth_date}}</span>
        </div>
        <div class="line-info">
          <span class="line-info-title">身份证号：</span><span>{{servicePerson.service_personnel_identity_card_number}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="line-info">
          <span class="line-info-title">性别：</span><span v-if="servicePerson.service_personnel_gender === '1'">男</span><span v-if="servicePerson.service_personnel_gender === '2'">女</span>
        </div>
        <div class="line-info">
          <span class="line-info-title">联系电话：</span><span>{{servicePerson.service_personnel_contact_number}}</span>
        </div>
        <div class="line-info">
          <span class="line-info-title">民族：</span><span>{{servicePerson.service_personnel_ethnic}}</span>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="line-info">
          <span class="line-info-title">户籍地址：</span><span>{{servicePerson.service_personnel_household_address}}</span>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="line-info">
          <span class="line-info-title">现居住址：</span><span>{{servicePerson.service_personnel_contact_address}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="line-info">
          <span class="line-info-title">政治面貌：</span><span>{{getNameShow(servicePerson.service_personnel_political_status_code)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="line-info">
          <span class="line-info-title">文化程度：</span><span>{{getNameCulturalShow(servicePerson.service_personnel_cultural_degree_code)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="line-info">
          <span class="line-info-title">岗位类型：</span><span>{{getJobCodeShow(servicePerson.service_personnel_job_code)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="line-info">
          <span class="line-info-title">岗位性质：</span><span>{{getJobNatureCodeShow(servicePerson.service_personnel_job_nature_code)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="line-info">
          <span class="line-info-title">入职时间：</span><span v-if="servicePerson.entry_date !== '0000-00-00'">{{servicePerson.entry_date}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="line-info">
          <span class="line-info-title">离职时间：</span><span v-if="servicePerson.service_personnel_departure_date !== '0000-00-00'">{{servicePerson.service_personnel_departure_date}}</span>
        </div>
      </el-col>
    </el-col>
  </el-row>
</div>
</template>

<script>
export default {
  name: 'detailsInfoOpen',
  model: {
    prop: 'detailsShow',
    event: 'change'
  },
  props: {
    staffRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      servicePerson: '',
      politicalArr: [],
      educationArr: [],
      jobCodeArr: [],
      jobNatureCodeArr: []
    }
  },
  created () {
    this.politicalArr = this.commonType.getPoliticalArr()
    this.educationArr = this.commonType.getEducationArr()
    this.jobCodeArr = this.commonType.getJobCodeArr()
    this.jobNatureCodeArr = this.commonType.getJobNatureCodeArr()
    this.servicePerson = this.staffRow.row
  },
  methods: {
    getNameShow (type) {
      let name = type
      for (let i = 0; i < this.politicalArr.length; i++) {
        if (type === this.politicalArr[i].id) {
          name = this.politicalArr[i].name
        }
      }
      return name
    },
    getNameCulturalShow (type) {
      let name = type
      for (let i = 0; i < this.educationArr.length; i++) {
        if (type === this.educationArr[i].id) {
          name = this.educationArr[i].name
        }
      }
      return name
    },
    getJobCodeShow (type) {
      let result = type
      let jobCode = this.jobCodeArr.find(r => r.id === type.toString())
      if (jobCode) {
        result = jobCode.name
      }
      return result
    },
    getJobNatureCodeShow (type) {
      let result = type
      let jobNatureCode = this.jobNatureCodeArr.find(r => r.id === type.toString())
      if (jobNatureCode) {
        result = jobNatureCode.name
      }
      return result
    }
  }
}
</script>

<style scoped>
.line-info{
  font-size: 16px;
  height: 30px;
  color: #1a1a1a;
}
.line-info-title{
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/detailsInfoOpen.vue